export const StatusEnum = {
  Success: 'success',
  Warning: 'warning',
  Info: 'info',
  Error: 'error',
  Neutral: 'neutral',
  Special: 'special',
} as const;
